import React from "react";
import "./AuthOptionsButtons.css";
import { getAnalytics, logEvent } from "firebase/analytics";
import { isDevEnvironment } from "env/runtimeEnv";
import { useVisualViewportLayout } from "hooks/useVisualViewportLayout";

interface AuthOptionsButtonsProps {
  email: string;
  onEmailChange: (email: string) => void;
  onSubmit: () => Promise<void>;
  isLoading: boolean;
  isOnline: boolean;
  loadingStates: any;
}

export default function AuthOptionsButtons({
  email,
  onEmailChange,
  onSubmit,
  isLoading,
  loadingStates,
}: AuthOptionsButtonsProps) {
  const { bottomInset } = useVisualViewportLayout();
  const analytics = getAnalytics();
  logEvent(analytics, "select_content", {
    content_type: "image",
    content_id: "P12453",
  });

  return (
    <div className="auth-options-container">
      <div className="auth-options-content">
        <div className="auth-options-header">
          <div className="logo-container">
            <div className="logo-wrapper">
              <img
                src="/logo512.png"
                alt="Experience App Icon"
                className="logo-image"
              />
            </div>
          </div>

          {isDevEnvironment && (
            <h1 className="auth-env-label">DEV</h1>
          )}

          <h1 className="welcome-title">Your email</h1>
        </div>

        <div className="auth-email-form-wrapper">
          {loadingStates?.users ? (
              <div className="auth-loading-wrapper">
                <div className="auth-loading-spinner" aria-hidden />
                <p className="auth-loading-message">Loading user data...</p>
              </div>
          ) : (
              <input
                  type="email"
                  value={email || ""}
                  onChange={(e) => onEmailChange && onEmailChange(e.target.value)}
                  placeholder="name@example.com"
                  className="auth-email-input"
              />
          )}
        </div>
      </div>

      <div
        className="auth-options-footer"
        style={{ "--keyboard-inset": `${bottomInset}px` } as React.CSSProperties}
      >

        {!loadingStates?.users && (
          <button
            onClick={onSubmit}
            disabled={!email}
            className="proceed-button auth-options-submit"
          >
            {isLoading ? "Sending..." : "Continue"}
          </button>
        )}
      </div>
    </div>
  );
}
